import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterArticle_template } from "./filterArticle_template";
import { filterTag_template } from "./filterTag_template";
import { filterVideo_template } from "./filterVideo_template";
import { filterListingPage_template } from "./filterListingPage_template";
import { filterUser_template } from "./filterUser_template";
import { buildStreamingServiceHtmlFromTag } from "../../utils/AffiliateLinkHelper";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";

declare var ko: any;

export class vignettePreview_template extends vnTemplate {
    protected tagFilter: filterTag_template;
    protected articleFilter: filterArticle_template;
    protected videoFilter: filterVideo_template;
    protected listingPageFilter: filterListingPage_template;
    protected hubPageFilter: filterListingPage_template;
    protected imagePicker: imagePicker_template;
    protected imagePickerHelper: imagePickerHelper;
    protected authorFilter: filterUser_template;

    public static getTagDefaults(): any {
        return [
            { key: 'TAG NAME', value: 'default_name' },
            { key: 'TAG ID', value: 'default_tag_id' },
            { key: 'IMAGE', value: 'default_image_url' },
            { key: 'BANNER IMAGE', value: 'default_banner_image_url' },
            { key: 'ICON', value: 'default_icon_url' },
            { key: 'COLOR', value: 'default_color' },
            { key: 'OWNER BRAND HUB URL', value: 'owner_brand_hub_url' },
            { key: 'DEFAULT HUB PAGE URL', value: 'default_hub_page_url' },
            { key: 'TAG TYPE', value: 'default_tag_type' },
            { key: 'DATASET', value: 'default_dataset' },
            { key: 'SEO DESCRIPTION', value: 'default_seo_description' },
            { key: 'REVIEW SCORE', value: 'default_review_score' },
            { key: 'DESCRIPTION', value: 'default_description' },
            { key: 'STREAMING SERVICES', value: 'default_streaming_services_s' },
        ]
    }

    public static getArticleDefaults(): any {
        return [
            { key: 'ARTICLE NAME', value: 'article_default_name' },
            { key: 'IMAGE', value: 'article_default_image_url' },
            { key: 'URL', value: 'article_default_url' },
            { key: 'CONTENT TYPE', value: 'article_default_content_type' },
            { key: 'CONTENT TYPE COLOR', value: 'article_default_content_type_color' },
            { key: 'EXCERPT', value: 'article_default_excerpt' },
            { key: 'DATE PUBLISHED', value: 'article_default_date_published' },
            { key: 'DISPLAY AUTHOR', value: 'article_default_author' },
            { key: 'DISPLAY AUTHOR URL', value: 'article_default_author_url' },
            { key: 'COMMENT COUNT', value: 'article_default_comment_count' },
            { key: 'HAS VIDEO', value: 'article_default_has_video' },
            { key: 'VIDEO LENGTH', value: 'article_default_video_length' },
            { key: 'PRIMARY TAG', value: 'article_default_primary_tag' },
            { key: 'SECONDARY TAGS', value: 'article_default_secondary_tags' },
            { key: 'PRIMARY CATEGORY', value: 'article_default_primary_category' },
            { key: 'SECONDARY CATEGORIES', value: 'article_default_secondary_categories' },
            { key: 'REVIEW TAG', value: 'article_default_review_tag' },
            { key: 'SEGMENT', value: 'article_default_segment' },
            { key: 'CLASSIFICATION', value: 'article_default_classification' },
        ]
    }

    public static getImageDefaults(): any {
        return [
            { key: 'IMAGE NAME', value: 'image_default_name' },
            { key: 'IMAGE URL', value: 'image_default_url' },
            { key: 'ALT TEXT', value: 'image_default_alt_text' },
        ]
    }

    public static getVideoDefaults(): any {
        return [
            { key: 'VIDEO NAME', value: 'video_default_name' },
            { key: 'VIDEO URL', value: 'video_default_url' },
            { key: 'THUMBNAIL URL', value: 'video_default_thumbnail_url' },
            { key: 'DESCRIPTION', value: 'video_default_description' },
            { key: 'LENGTH', value: 'video_default_length' },
            { key: 'MIME TYPE', value: 'video_default_mime_type' },
            { key: 'WIDTH', value: 'video_default_width' },
            { key: 'HEIGHT', value: 'video_default_height' },
            { key: 'RATIO', value: 'video_default_ratio' },
            { key: 'PRIMARY CONTENT TYPE', value: 'video_default_primary_content_type' },
            { key: 'PRIMARY CONTENT TYPE COLOR', value: 'video_default_primary_content_type_color' },
            { key: 'PRIMARY CATEGORY', value: 'video_default_primary_category' },
            { key: 'PRIMARY TAG', value: 'video_default_primary_tag' },
        ]
    }

    public static getHubDefaults(): any {
        return [
            { key: 'HUB NAME', value: 'hub_default_name' },
            { key: 'URL', value: 'hub_default_url' },
            { key: 'DESCRIPTION', value: 'hub_default_description' },
            { key: 'BANNER IMAGE', value: 'hub_default_banner_image_url' },
            { key: 'THUMBNAIL IMAGE', value: 'hub_default_thumbnail_image_url' }
        ]
    }

    public static getBrandDefaults(): any {
        return [];
    }

    public static getReferencePlaceholder(reference: any): string {
        return reference && reference.value ? `[[${reference.value}]]` : '';
    }

    public static copyReferenceToClipboard(reference: any): boolean {
        const placeholder = vignettePreview_template.getReferencePlaceholder(reference);
        if (!placeholder) {
            return false;
        }

        const clipboard = window.navigator['clipboard'];
        if (clipboard && typeof clipboard.writeText === 'function') {
            clipboard.writeText(placeholder);
            return true;
        }

        return vignettePreview_template.copyTextWithExecCommand(placeholder);
    }

    // navigator.clipboard is only available in secure contexts.
    protected static copyTextWithExecCommand(text: string): boolean {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (e) {
            copied = false;
        }

        document.body.removeChild(textarea);

        return copied;
    }

    protected getTemplateHtml(): string {

        return /*html*/ `
            <div class="form-group vignette-preview-filters">
                <div class="form-group vignette-preview-custom-variables" data-bind="visible: customVariables().length > 0">
                    <div data-bind="event: { click: onClickToggleCustomVariables }" style="cursor: pointer;" class="custom-variables-header">
                        <label class="form-label">Custom Variables</label>
                        <button type="button" class="btn small">
                            <i class="icon i-dropdown-simple" data-bind="css: { 'open': customVariablesShown, 'closed': !customVariablesShown() }"></i>
                        </button>
                    </div>
                    <div data-bind="visible: customVariablesShown, foreach: customVariables" class="custom-variables-list">
                        <div class="variable-row" style="display:flex; gap:8px; align-items:center; margin-top:8px;">
                            <label class="form-label" style="min-width:180px;" data-bind="text: name"></label>
                            <input type="text" class="input-text" style="flex:1;" data-bind="value: $parent.getCustomVariableValue(name), valueUpdate: 'afterkeydown', event: { keyup: $parent.onCustomVariableInput, change: $parent.onCustomVariableInput }, attr: { placeholder: name }" />
                        </div>
                    </div>
                </div>
                <div class="form-group vignette-preview-image-overrides" data-bind="visible: imageOverrideVariables().length > 0">
                     <div data-bind="event: { click: onClickToggleImageOverrides }" style="cursor: pointer;" class="custom-variables-header">
                        <label class="form-label">Image Overrides</label>
                        <button type="button" class="btn small">
                            <i class="icon i-dropdown-simple" data-bind="css: { 'open': imageOverridesShown, 'closed': !imageOverridesShown() }"></i>
                        </button>
                    </div>

                    <div data-bind="visible: imageOverridesShown, foreach: imageOverrideVariables" class="image-overrides-list">
                        <div class="variable-row" style="display:flex; gap:8px; align-items:center; margin-top:8px; flex-wrap:wrap">
                            <label class="form-label" style="min-width:100%;" data-bind="text: name"></label>
                            <input type="text" class="input-text" style="flex:1;" data-bind="value: $parent.getImageOverrideVariableValue(name), valueUpdate: 'afterkeydown', event: { keyup: $parent.onImageOverrideInput, change: $parent.onImageOverrideInput }, attr: { placeholder: name }" />
                            <button type="button" class="btn icon i-image" data-bind="event: { click: $parent.onClickOverrideImageVariable }">Select Image</button>
                        </div>
                    </div>
                </div>
                <div class="vignette-preview-article-variables">
                    <div class="article-variables-header">
                        <label class="form-label">Articles</label>  
                    </div>
                    <div class="article-variables-list">
                        <div class="vignette-filter">
                            ${ this.articleFilter.getHtmlBuild() }
                            <div id="selected-articles" class="selected-filters"></div>
                        </div>
                        <div class="vignette-filter">
                            ${ this.listingPageFilter.getHtmlBuild() }
                        </div>
                        <div class="vignette-filter">
                            ${ this.authorFilter.getHtmlBuild() }
                            <div id="vignette-preview-selected-author" class="selected-filters"></div>
                        </div>
                    </div>
                </div>
                <div class="vignette-filter">
                    ${ this.videoFilter.getHtmlBuild() }
                    <div id="selected-videos" class="selected-filters"></div>
                </div>
                <div class="vignette-filter">
                    ${ this.tagFilter.getHtmlBuild() }
                <div id="selected-tags" class="selected-filters"></div>
                </div>
                <div class="vignette-filter">
                    ${ this.hubPageFilter.getHtmlBuild() }
                    <div id="selected-hub-pages" class="selected-filters"></div>
                </div>
                <div class="vignette-filter image-picker-container">
                    <button type="button" class="btn icon i-image" data-bind="event: { click: onClickAddImage }">Select Images</button>
                    <div id="selected-images" class="selected-filters" data-bind="foreach: allSelectedImages">
                        <!-- ko if: $index() === 0 -->
                        <label class="small">Selected Images:</label>
                        <!-- /ko -->
                        <button type="button" class="btn-f-s icon i-x-after null" data-bind="attr: { id: id }, text: name || url, event: { click: $parent.onClickRemoveImage }"></button>
                    </div>
                </div>
            </div>
            <div id="previewContainer" style="width: 100%;">
                <iframe id="preview" width="100%" class="w-iframe" style="height: 300px;" data-bind="event: { load: iframeOnLoad }, attr: { srcdoc: previewHtml }, visible: html() != ''" sandbox="allow-same-origin"></iframe>
            </div>
            ${ this.imagePicker ? this.imagePicker.getHtmlBuild() : '' }
        `;
    }

    protected initPartial(): void {

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.setSelectionMode(filterTag_template.MULTIPLE_SELECTION_MODE);

        this.articleFilter = new filterArticle_template("articleFilter", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setIsLoadingAnimationEnable(true);
        this.articleFilter.setSelectionMode(filterArticle_template.MULTIPLE_SELECTION_MODE);
        this.articleFilter.setShowDetails(true);

        this.videoFilter = new filterVideo_template("videoFilter", this.getTemplateViewModel(), this.caller);
        this.videoFilter.setIsLoadingAnimationEnable(true);
        this.videoFilter.setSelectionMode(filterVideo_template.MULTIPLE_SELECTION_MODE);
        this.videoFilter.setShowDetails(true);

        this.hubPageFilter = new filterListingPage_template("hubPageFilter", this.getTemplateViewModel(), this.caller);
        this.hubPageFilter.setShowDetails(true);
        this.hubPageFilter.setPlaceholder("Hub Page");
        this.hubPageFilter.setSelectionMode(filterListingPage_template.MULTIPLE_SELECTION_MODE);
        this.hubPageFilter.setTagContainerId("selected-hub-pages");
        this.hubPageFilter.setIsLoadingAnimationEnable(true);

        this.listingPageFilter = new filterListingPage_template("listingPageFilter", this.getTemplateViewModel(), this.caller);
        this.listingPageFilter.setShowDetails(true);
        this.listingPageFilter.setIsLoadingAnimationEnable(true);

        this.imagePicker = new imagePicker_template("vignettePreviewImagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setMode("single-select");
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.getTemplateViewModel(), this.caller.getVnAppZone(), this.caller);

        this.authorFilter = new filterUser_template("authorFilter", this.getTemplateViewModel(), this.caller);
        this.authorFilter.setSelectionMode(filterUser_template.SINGLE_SELECTION_MODE);
        this.authorFilter.setPlaceholderText("Author");
        this.authorFilter.setTagContainerId("vignette-preview-selected-author");
        this.authorFilter.setUniqueIdentifier("vignettePreviewAuthorId");
        this.authorFilter.setIsLoadingAnimationEnable(true);
        this.authorFilter.setNotifyIdElementOnChange(true);
    }

    protected getTemplateName(): string {

        return "vignettePreview_template";
    }

    protected buildViewModel(): any {

        const self = this;
        const html = ko.observable("");
        const css = ko.observable("");
        const js = ko.observable("");
        const showKeys = ko.observable(false);
        const indexedCssValues = ko.observable({});
        const indexedHtmlValues = ko.observable({});
        const indexedJsValues = ko.observable({});
        const customVariablesShown = ko.observable(true);
        const imageOverrideVariableName = ko.observable(null);
        const imageOverridesShown = ko.observable(true);
        return {
            html: html,
            css: css,
            js: js,
            showKeys: showKeys,
            indexedCssValues: indexedCssValues,
            indexedHtmlValues: indexedHtmlValues,
            indexedJsValues: indexedJsValues,
            customVariablesShown: customVariablesShown,
            customVariables: ko.pureComputed(() => {
                return self.getCustomVariables();
            }),
            imageOverrideVariables: ko.pureComputed(() => {
                return self.getImageOverrideVariables();
            }),
            imageOverridesShown: imageOverridesShown,
            previewHtml: ko.pureComputed(() => {
                return self.updatePreviewInternal(html(), css(), js(), showKeys(), indexedHtmlValues(), indexedCssValues(), indexedJsValues());
            }),
            isFixedHeight: ko.observable(false),
            defaultHeight: ko.observable("300px"),
            iframeOnLoad: this.iframeOnLoad.bind(this),
            onClickToggleCustomVariables: this.onClickToggleCustomVariables.bind(this),
            onCustomVariableInput: this.onCustomVariableInput.bind(this),
            getCustomVariableValue: this.getCustomVariableValue.bind(this),
            imageOverrideVariableName: imageOverrideVariableName,
            onImageOverrideInput: this.onImageOverrideInput.bind(this),
            onClickOverrideImageVariable: this.onClickOverrideImageVariable.bind(this),
            getImageOverrideVariableValue: this.getImageOverrideVariableValue.bind(this),
            allSelectedArticles: ko.observableArray([]),
            allSelectedImages: ko.observableArray([]),
            onClickAddImage: this.onClickAddImage.bind(this),
            onClickRemoveImage: this.onClickRemoveImage.bind(this),
            onClickToggleImageOverrides: this.onClickToggleImageOverrides.bind(this),
        }
    }

    protected iframeOnLoad(data, event){
        const iframe = event.target;
        this.updateHeight(iframe);
        this.setupAutoResizeShortPolling(iframe);
    }

    protected updateHeight(target): void {
        if(!target) { return; }
        if(this.getTemplateViewModel().isFixedHeight()) {
            target.style.height = this.getTemplateViewModel().defaultHeight();
            target.style.overflow = 'auto';
        } else {
            const win = target.contentWindow;
            const doc = target.contentDocument || (win ? win.document : null);
            if(!doc) { return; }
            const body = doc.body;
            const html = doc.documentElement;


            const heights = [
                body ? body.scrollHeight : 0,
                body ? body.offsetHeight : 0,
                body ? body.clientHeight : 0,
                html ? html.scrollHeight : 0,
                html ? html.offsetHeight : 0,
                html ? html.clientHeight : 0
            ];

            const contentHeight = Math.max.apply(null, heights);
            const minHeight = 50; // px
            target.style.height = Math.max(contentHeight, minHeight) + 'px';
        }
    }

    protected setupAutoResizeShortPolling(iframe: HTMLIFrameElement): void {
        const win = iframe.contentWindow;
        const doc = iframe.contentDocument || (win ? win.document : null);
        if (!doc) { return; }


        [0, 100, 250, 500, 1000].forEach((delay) =>
            setTimeout(() => this.updateHeight(iframe), delay)
        );

        const started = Date.now();
        const interval = setInterval(() => {
            this.updateHeight(iframe);
            if (Date.now() - started > 2000) {
                clearInterval(interval);
            }
        }, 100);


        doc.addEventListener('load', () => this.updateHeight(iframe), true);

        const fonts: any = (doc as any).fonts;
        if (fonts && fonts.ready && typeof fonts.ready.then === 'function') {
            fonts.ready.then(() => this.updateHeight(iframe));
        }
    }

    public setIsFixedHeight(value: boolean): void {
        this.getTemplateViewModel().isFixedHeight(value);
    }

    public setDefaultHeight(value: string): void {
        this.getTemplateViewModel().defaultHeight(value);
    }

    public setVignette(vignette) {
        let html = '';
        let css = '';
        let js = '';

        if(vignette) {
            html = vignette.html;
            css = vignette.css;
            js = vignette.js;
        }

        this.getTemplateViewModel().html(html);
        this.getTemplateViewModel().css(css);
        this.getTemplateViewModel().js(js);
    }

    public setHtml(value): void {
        this.getTemplateViewModel().html(value);
    }

    public setCss(value): void {
        this.getTemplateViewModel().css(value);
    }

    public setJs(value): void {
        this.getTemplateViewModel().js(value);
    }

    public setShowKeys(value): void {
        this.getTemplateViewModel().showKeys(value);
    }

    public onClickToggleCustomVariables(): void {
        const vm = this.getTemplateViewModel();
        vm.customVariablesShown(!vm.customVariablesShown());
    }

    public onCustomVariableInput(data, event): boolean {
        if (data && data.name && event && event.target) {
            this.setCustomVariableValue(data.name, event.target.value);
        }
        return true;
    }

    public onClickToggleImageOverrides(): void {
        const vm = this.getTemplateViewModel();
        vm.imageOverridesShown(!vm.imageOverridesShown());
    }

    public setAllSelectedArticles(value): void {
        this.getTemplateViewModel().allSelectedArticles(value);
    }

    public getAllSelectedArticles(): any {
        return this.getTemplateViewModel().allSelectedArticles();
    }

    public setAllSelectedImages(value): void {
        this.getTemplateViewModel().allSelectedImages(value);
    }

    public getAllSelectedImages(): any {
        return this.getTemplateViewModel().allSelectedImages();
    }

    public onClickAddImage(): void {
        this.getTemplateViewModel().imageOverrideVariableName(null);
        this.openImagePicker();
    }

    protected openImagePicker(): void {
        if (!this.imagePicker || !this.imagePickerHelper) {
            return;
        }

        this.imagePicker.setIsImageOptimizable(false);
        this.imagePicker.setMode("single-select");
        this.imagePicker.setTarget("vignettePreviewImage");
        this.imagePicker.setSelectedImages([]);
        this.imagePickerHelper.getImageData();
        this.imagePicker.show();
    }

    public onClickRemoveImage(image): void {
        const selectedImages = this.getAllSelectedImages().filter((selectedImage) => {
            return !selectedImage || !image || String(selectedImage.id) !== String(image.id);
        });

        this.setAllSelectedImages(selectedImages);
        this.setIndexedValuesForImages(selectedImages);
    }

    public addIndexedImage(image): void {
        if (!image) {
            return;
        }

        const overrideVariableName = this.getTemplateViewModel().imageOverrideVariableName();
        if (overrideVariableName) {
            this.setImageOverrideVariableValue(overrideVariableName, image.url || '');
            this.getTemplateViewModel().imageOverrideVariableName(null);
            return;
        }

        let selectedImages = this.getAllSelectedImages();
        selectedImages.push(image);
        selectedImages = selectedImages.filter((selectedImage, index, self) => {
            return index === self.findIndex((item) => String(item.id) === String(selectedImage.id));
        });

        this.setAllSelectedImages(selectedImages);
        this.setIndexedValuesForImages(selectedImages);
    }

    protected renderTemplate(content: string, replacement: any, showKeys: boolean): string {
        if (!content) return '';
        return content.replace(/\[\[\s*([^\]\[]+?)\s*\]\]/g, (match, keyRaw) => {
            const key = String(keyRaw).trim().toLowerCase();
            const hasValue = Object.prototype.hasOwnProperty.call(replacement, key)
                && replacement[key] !== undefined
                && replacement[key] !== null;
            if (showKeys) {
                return hasValue ? replacement[key] : match;
            }
            return hasValue ? replacement[key] : '';
        });
    }

    protected updatePreviewInternal(html: string, css: string, js: string, showKeys: boolean, indexedHtml: any, indexedCss: any, indexedJs: any): string {
        let renderedCss = this.renderTemplate(css, indexedCss, showKeys);
        let renderedHtml = this.renderTemplate(html, indexedHtml, showKeys);
        let renderedJs = this.renderTemplate(js, indexedJs, showKeys);

        const emptyTagsRegex = /<(style|script)\b[^>]*>[\s\r\n]*<\/\1>|<(style|script)\b[^>]*\/>/gi;

        if (renderedHtml) {
            renderedHtml = renderedHtml.replace(emptyTagsRegex, "");
        }
        if (renderedJs) {
            renderedJs = renderedJs.replace(emptyTagsRegex, "");
        }

        if (renderedCss) {
            renderedCss = renderedCss.replace(/<\/?style\b[^>]*>/gi, '').trim();
        }
        if (renderedJs && renderedJs.trim() !== "") {
            if (renderedJs.toLowerCase().indexOf("<script") === -1) {
                renderedJs = "<script>\n" + renderedJs + "\n</script>";
            }
        }

        return /*html*/ `
            <html>
                <head>
                    <style>
                        body {
                            margin: 0;
                            padding: 0;
                            overflow: hidden;
                        }
                        ${renderedCss}
                    </style>
                </head>
                <body>
                    ${renderedHtml}
                    ${renderedJs}
                </body>
            </html>`;
    }

    //===============================================
    //shared helper functions
    protected assignIndexedValues(target: any, values: any): void {
        for (const k in values) {
            if (Object.prototype.hasOwnProperty.call(values, k) && values[k] !== undefined && values[k] !== null) {
                target[k] = values[k];
            }
        }
    }

    protected removeIndexedValues(target: any, shouldRemove: (key: string) => boolean): void {
        for (const k in target) {
            if (Object.prototype.hasOwnProperty.call(target, k) && shouldRemove(k)) {
                delete target[k];
            }
        }
    }

    protected setIndexedValuesCollection(values: any): void {
        this.getTemplateViewModel().indexedHtmlValues(Object.assign({}, values));
        this.getTemplateViewModel().indexedCssValues(Object.assign({}, values));
        this.getTemplateViewModel().indexedJsValues(Object.assign({}, values));
    }

    protected setPrefixedIndexedValues(prefix: string, indexedValues: any): void {
        const vm = this.getTemplateViewModel();
        const currentValues = Object.assign({}, vm.indexedHtmlValues());

        this.removeIndexedValues(currentValues, (key: string) => key.indexOf(prefix) === 0);
        this.assignIndexedValues(currentValues, indexedValues);

        this.setIndexedValuesCollection(currentValues);
    }

    protected clearPrefixedIndexedValues(prefix: string): void {
        this.setPrefixedIndexedValues(prefix, {});
    }

    protected getSlotKey(type: string, key: string, index: number): string {
        if (index === 0) {
            return key;
        }

        if (type === 'tag') {
            let tagKey = key;
            if (tagKey.indexOf('default_') === 0) {
                tagKey = tagKey.replace(/^default_/, '');
            } else if (tagKey.indexOf('tag_') === 0) {
                tagKey = tagKey.replace(/^tag_/, '');
            }
            return `tag_${index + 1}_${tagKey}`;
        }

        let itemKey = key;
        if (itemKey.indexOf(`${type}_default_`) === 0) {
            itemKey = itemKey.replace(new RegExp(`^${type}_default_`), '');
        } else if (itemKey.indexOf(`${type}_`) === 0) {
            itemKey = itemKey.replace(new RegExp(`^${type}_`), '');
        }

        return `${type}_${index + 1}_${itemKey}`;
    }

    //===============================================
    //custom variable related functions
    protected getCustomVariables(): any[] {
        const html = this.getTemplateViewModel().html() || '';
        const css = this.getTemplateViewModel().css() || '';
        const js = this.getTemplateViewModel().js() || '';
        const content = `${html} ${css} ${js}`;
        const placeholderRe = /\[\[\s*([^\]\[]+?)\s*\]\]/g;
        const seen = {};
        const variables = [];
        let match;

        while ((match = placeholderRe.exec(content)) !== null) {
            const name = String(match[1]).trim().toLowerCase();
            if (!name || seen[name] || this.isReservedPreviewVariable(name)) {
                continue;
            }

            seen[name] = true;
            variables.push({
                name: name
            });
        }

        return variables;
    }

    protected isReservedPreviewVariable(name: string): boolean {
        if (name.indexOf('article_default_') === 0 || /^article_\d+_/.test(name)) {
            return true;
        }
        if (name.indexOf('image_default_') === 0 || /^image_\d+_/.test(name)) {
            return true;
        }
        if (name.indexOf('video_default_') === 0 || /^video_\d+_/.test(name)) {
            return true;
        }
        if (name.indexOf('hub_default_') === 0 || /^hub_\d+_/.test(name)) {
            return true;
        }
        if (name.indexOf('default_') === 0 || /^tag_\d+_/.test(name)) {
            return true;
        }
        if (name.indexOf('brand_') === 0) {
            return true;
        }

        return name === 'tag_object'
            || name === 'default_tag_id'
            || name === 'owner_brand_hub_url'
            || name === 'default_hub_page_url';
    }

    protected getImageOverrideVariables(): any[] {
        const html = this.getTemplateViewModel().html() || '';
        const css = this.getTemplateViewModel().css() || '';
        const js = this.getTemplateViewModel().js() || '';
        const content = `${html} ${css} ${js}`;
        const placeholderRe = /\[\[\s*([^\]\[]+?)\s*\]\]/g;
        const seen = {};
        const variables = [];
        let match;

        while ((match = placeholderRe.exec(content)) !== null) {
            const name = String(match[1]).trim().toLowerCase();
            if (!name || seen[name] || !name.match(/_image_url$/)) {
                continue;
            }

            seen[name] = true;
            variables.push({ name: name });
        }

        return variables;
    }

    public onImageOverrideInput(data, event): boolean {
        if (data && data.name && event && event.target) {
            this.setImageOverrideVariableValue(data.name, event.target.value);
        }
        return true;
    }

    public onClickOverrideImageVariable(variable): void {
        if (!variable || !variable.name) {
            return;
        }

        this.getTemplateViewModel().imageOverrideVariableName(variable.name);
        this.openImagePicker();
    }

    protected getImageOverrideVariableValue(name: string): any {
        return this.getCustomVariableValue(name);
    }

    protected setImageOverrideVariableValue(name: string, value: any): void {
        this.setCustomVariableValue(name, value);
    }

    protected getCustomVariableValue(name: string): any {
        const values = this.getTemplateViewModel().indexedHtmlValues();
        return values && Object.prototype.hasOwnProperty.call(values, name) ? values[name] : '';
    }

    protected setCustomVariableValue(name: string, value: any): void {
        const values = Object.assign({}, this.getTemplateViewModel().indexedHtmlValues());
        values[name] = value;
        this.setIndexedValuesCollection(values);
    }

    public getMaxPlaceholderSlot(type: string): number {
        const maxSlot = this.getTotalPlaceholderSlots(type);
        const filledSlots = this.getFilledPlaceholderSlots(type);

        return Math.max(maxSlot - filledSlots, 0);
    }

    protected getTotalPlaceholderSlots(type: string): number {
        const html = this.getTemplateViewModel().html() || '';
        const css = this.getTemplateViewModel().css() || '';
        const js = this.getTemplateViewModel().js() || '';
        const content = `${html} ${css} ${js}`;
    
        let maxSlot = 0;
        const placeholderRe = /\[\[\s*([^\]\[]+?)\s*\]\]/g;
        let match;
    
        while ((match = placeholderRe.exec(content)) !== null) {
            const name = String(match[1]).trim();
    
            if (type === 'tag') {
                if (name.indexOf('default_') === 0 || name === 'default_tag_id') {
                    maxSlot = Math.max(maxSlot, 1);
                    continue;
                }
    
                const tagMatch = name.match(/^tag_(\d+)_/);
                if (tagMatch) {
                    maxSlot = Math.max(maxSlot, Number(tagMatch[1]));
                }
                continue;
            }
    
            const defaultPrefix = `${type}_default_`;
            if (name.indexOf(defaultPrefix) === 0) {
                maxSlot = Math.max(maxSlot, 1);
                continue;
            }
    
            const indexedMatch = name.match(new RegExp(`^${type}_(\\d+)_`));
            if (indexedMatch) {
                maxSlot = Math.max(maxSlot, Number(indexedMatch[1]));
            }
        }

        return maxSlot;
    }

    protected getFilledPlaceholderSlots(type: string): number {
        if (type === 'article') {
            const articles = this.getAllSelectedArticles();
            return Array.isArray(articles) ? articles.length : 0;
        }

        return 0;
    }

    //===============================================
    //tag related functions
    public setIndexedValues(tag, specValues: Array<any> = [], specDefaults: Array<any> = [], extraDefaults: { [key: string]: any } = {}) {
        this.setTagIndexedValues(this.getIndexedValuesForTag(tag, specValues, specDefaults, extraDefaults));
    }

    public setIndexedValuesForTags(tags: any[]): void {
        if (!Array.isArray(tags) || tags.length === 0) {
            this.clearTagIndexedValues();
            return;
        }

        let indexedValues = {};

        tags.forEach((tag, index) => {
            const tagValues = this.getIndexedValuesForTag(
                tag,
                tag.previewSpecValues || [],
                tag.previewSpecDefaults || [],
                tag.previewExtraDefaults || {}
            );

            for (const key in tagValues) {
                if (Object.prototype.hasOwnProperty.call(tagValues, key)) {
                    indexedValues[this.getTagSlotKey(key, index)] = tagValues[key];
                }
            }
        });

        this.setTagIndexedValues(indexedValues);
    }

    public clearTagIndexedValues(): void {
        this.setTagIndexedValues({});
    }

    protected getTagSlotKey(key: string, index: number): string {
        if (index === 0) {
            if (key === 'tag_object'
                || key === 'default_tag_id'
                || key === 'owner_brand_hub_url'
                || key === 'default_hub_page_url'
                || key.indexOf('default_') === 0) {
                return key;
            }

            return `default_${key}`;
        }

        let tagKey = key;
        if (tagKey === 'default_tag_id') {
            tagKey = 'id';
        } else if (tagKey.indexOf('default_') === 0) {
            tagKey = tagKey.replace(/^default_/, '');
        } else if (/^tag_\d+_/.test(tagKey)) {
            tagKey = tagKey.replace(/^tag_\d+_/, '');
        } else if (tagKey.indexOf('tag_') === 0 && tagKey !== 'default_tag_id') {
            tagKey = tagKey.replace(/^tag_/, '');
        }

        return `tag_${index + 1}_${tagKey}`;
    }

    private getIndexedValuesForTag(tag, specValues: Array<any> = [], specDefaults: Array<any> = [], extraDefaults: { [key: string]: any } = {}) {
        let indexedHtmlValues = {};

        if(tag) {
            let tagTypeField: any;
            let specHtmlValue: string;
            let reference: string;
            if(tag.type) {
                const processSpec = (spec: any) => {
                    if (spec.isDefault) {
                        // default specs should be ignored.
                        return;
                    }
                    specHtmlValue = '';
                    tagTypeField = tag.type.fields.find((field: any) => field.id === spec.fieldId);
                    if(tagTypeField && tagTypeField.reference){
                        if (spec.dataType === 'tag') {
                            specHtmlValue = spec.value && spec.value[0] ? spec.value[0].name : null;
                        } else if (spec.dataType === 'tags') {
                            let values = [];
                            if (Array.isArray(spec.value)) {
                                values = spec.value;
                            } else if (spec.originalValue && Array.isArray(spec.originalValue)) {
                                values = spec.originalValue;
                            }

                            if (Array.isArray(values)) {
                                specHtmlValue = values.map((tag: any) => {
                                    return `<span class="${tag.slug}">${tag.name}</span>`;
                                }).join('');
                            } else {
                                specHtmlValue = spec.value;
                            }
                        } else {
                            specHtmlValue = spec.value;
                        }

                        reference = tagTypeField.reference.toLowerCase();
                        indexedHtmlValues[reference] = specHtmlValue;
                    }
                };

                // process the defaults first.
                specDefaults.forEach(processSpec);
                // any spec values that aren't default will overwrite the reference.
                specValues.forEach(processSpec);
            }

            const indexedDefaultValues = this.getDefaultIndexedValues(tag);

            Object.assign(indexedHtmlValues, indexedDefaultValues);

            if (extraDefaults && typeof extraDefaults === 'object') {
                for (const k in extraDefaults) {
                    if (Object.prototype.hasOwnProperty.call(extraDefaults, k)) {
                        const v = extraDefaults[k] || '';
                        (indexedHtmlValues as any)[k] = v;
                    }
                }
            }
        }

        return indexedHtmlValues;
    }

    public setTagIndexedValues(indexedValues: any): void {
        const vm = this.getTemplateViewModel();
        const currentValues = Object.assign({}, vm.indexedHtmlValues());

        this.removeIndexedValues(currentValues, (key: string) => this.isReservedTagVariable(key));
        this.assignIndexedValues(currentValues, indexedValues);

        this.setIndexedValuesCollection(currentValues);
    }

    protected isReservedTagVariable(key: string): boolean {
        return key === 'tag_object'
            || key === 'default_tag_id'
            || key === 'owner_brand_hub_url'
            || key === 'default_hub_page_url'
            || key.indexOf('default_') === 0
            || /^tag_\d+_/.test(key);
    }

    private getDefaultIndexedValues(tag) {
        let indexedValues = {};

        const seen = new WeakSet();
        indexedValues['tag_object'] = JSON.stringify(tag, (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) return undefined;
                seen.add(value);
            }
            return value;
        });
        indexedValues['default_tag_id'] = tag.id != null ? String(tag.id) : '';
        indexedValues['default_name'] = tag.name;
        if(tag.type) {
            indexedValues['default_tag_type'] = tag.type.name;
            indexedValues['default_dataset'] = tag.type.dataset ? tag.type.dataset.name : '';
        }

        indexedValues['default_color'] = tag.defaults.color;
        indexedValues['default_image_url'] = tag.defaults.image ? tag.defaults.image.url : '';
        indexedValues['default_banner_image_url'] = tag.defaults.bannerImage ? tag.defaults.bannerImage.url : '';
        indexedValues['default_icon_url'] = tag.defaults.iconImage ? tag.defaults.iconImage.url : '';
        indexedValues['default_seo_description'] = tag.defaults.shortDescription;
        indexedValues['default_review_score'] = tag.defaults.reviewScore;
        indexedValues['default_description'] = tag.defaults.description;

        let ownerBrandHubUrl = '';
        if (tag.urlHubPage && tag.urlHubPage) {
            ownerBrandHubUrl = tag.urlHubPage;
        }

        indexedValues['owner_brand_hub_url'] = ownerBrandHubUrl;
        indexedValues['default_streaming_services_s'] = buildStreamingServiceHtmlFromTag(tag);

        if(tag.details) {
            if (tag.details.color) {
                indexedValues['default_color'] = tag.details.color;
            }
            if (tag.details.image) {
                indexedValues['default_image_url'] = tag.details.image.url;
            }
            if (tag.details.bannerImage) {
                indexedValues['default_banner_image_url'] = tag.details.bannerImage.url;
            }
            if (tag.details.iconImage) {
                indexedValues['default_icon_url'] = tag.details.iconImage.url;
            }
            if (tag.details.shortDescription) {
                indexedValues['default_seo_description'] = tag.details.shortDescription;
            }
            if (tag.details.reviewScore) {
                indexedValues['default_review_score'] = tag.details.reviewScore;
            }
            if (tag.details.description) {
                indexedValues['default_description'] = tag.details.description;
            }
        }

        return indexedValues;
    }

    //===============================================
    //article related functions
    public setIndexedValuesForArticle(article){
        if(!article) {
            this.clearIndexedValuesForArticle();
            return;
        }
        this.setIndexedValuesForArticles([article]);
    }

    public setIndexedValuesForArticles(articles: any[]): void {
        if (!Array.isArray(articles) || articles.length === 0) {
            this.clearIndexedValuesForArticle();
            return;
        }

        let indexedValues = {};

        articles.forEach((article, index) => {
            const articleValues = vignettePreview_template.getDefaultIndexedValuesForArticle(article);
            for (const key in articleValues) {
                if (Object.prototype.hasOwnProperty.call(articleValues, key)) {
                    indexedValues[this.getSlotKey('article', key, index)] = articleValues[key];
                }
            }
        });

        this.setPrefixedIndexedValues('article_', indexedValues);
    }

    public clearIndexedValuesForArticle(): void {
        this.clearPrefixedIndexedValues('article_');
    }

    public static getDefaultIndexedValuesForArticle(article){
        if(!article) {
            return {};
        }
        let indexedValues = {};
        indexedValues['article_default_name'] = article.title || '';
        indexedValues['article_default_image_url'] = article.featuredImage ? article.featuredImage.url : '';
        indexedValues['article_default_url'] = article.permalink || '';
        indexedValues['article_default_content_type'] = article.contentType ? article.contentType.name : '';
        indexedValues['article_default_content_type_color'] = article.contentType ? article.contentType.color : '';
        indexedValues['article_default_excerpt'] = article.excerpt || '';
        indexedValues['article_default_date_published'] = article.dateMostRecentPublishedStatus && article.dateMostRecentPublishedStatus.date ? article.dateMostRecentPublishedStatus.date.substring(0, 19) : '';
        
        //author name
        let authorName = article.author && article.author.valnet_user && article.author.valnet_user.fullName ? article.author.valnet_user.fullName : '';
        if(article.displayAuthors && article.displayAuthors.length > 0) {
            authorName = article.displayAuthors[0].valnet_user && article.displayAuthors[0].valnet_user.fullName ? article.displayAuthors[0].valnet_user.fullName : '';
        }
        indexedValues['article_default_author'] = authorName;

        //author url
        indexedValues['article_default_author_url'] = article.brandInfo ? article.brandInfo.niceName : '';

        //comment count
        indexedValues['article_default_comment_count'] = article.commentsCount || 0;

        //has video
        indexedValues['article_default_has_video'] =  article.featuredVideo ? '1' : '0';
        indexedValues['article_default_video_length'] = article.featuredVideo ? article.featuredVideo.length || '' : '';

        //tags and categories
        indexedValues['article_default_primary_tag'] = article.primaryTag ? article.primaryTag.name : '';
        indexedValues['article_default_secondary_tags'] = vignettePreview_template.buildNameListJson(article.tags, 'tag');
        indexedValues['article_default_primary_category'] = article.primaryCategory ? article.primaryCategory.name : '';
        indexedValues['article_default_secondary_categories'] = vignettePreview_template.buildNameListJson(article.categories, 'category');
        indexedValues['article_default_review_tag'] = article.reviewTag ? article.reviewTag.name : '';

        //segment and classification
        indexedValues['article_default_segment'] = article.segment ? article.segment.name : '';
        indexedValues['article_default_classification'] = article.classification ? article.classification.name : '';

        return indexedValues;
    }

    private static buildNameListJson(items: any[], property: string): string {
        if(!Array.isArray(items) || items.length === 0) {
            return '';
        }

        const names = items
            .map((item) => item && item[property] ? item[property].name : '')
            .filter((name) => !!name);

        return names.length > 0 ? JSON.stringify(names) : '';
    }

    //===============================================
    //image related functions
    public setIndexedValuesForImages(images: any[]): void {
        if (!Array.isArray(images) || images.length === 0) {
            this.clearIndexedValuesForImages();
            return;
        }

        let indexedValues = {};

        images.forEach((image, index) => {
            const imageValues = this.getDefaultIndexedValuesForImage(image);
            for (const key in imageValues) {
                if (Object.prototype.hasOwnProperty.call(imageValues, key)) {
                    indexedValues[this.getSlotKey('image', key, index)] = imageValues[key];
                }
            }
        });

        this.setPrefixedIndexedValues('image_', indexedValues);
    }

    public clearIndexedValuesForImages(): void {
        this.clearPrefixedIndexedValues('image_');
    }

    private getDefaultIndexedValuesForImage(image){
        if(!image) {
            return {};
        }

        let indexedValues = {};
        indexedValues['image_default_name'] = image.name || '';
        indexedValues['image_default_url'] = image.url || '';
        indexedValues['image_default_alt_text'] = image.altText || '';

        return indexedValues;
    }

    //===============================================
    //video related functions
    public setIndexedValuesForVideos(videos: any[]): void {
        if (!Array.isArray(videos) || videos.length === 0) {
            this.clearIndexedValuesForVideo();
            return;
        }

        let indexedValues = {};

        videos.forEach((video, index) => {
            const videoValues = this.getDefaultIndexedValuesForVideo(video);
            for (const key in videoValues) {
                if (Object.prototype.hasOwnProperty.call(videoValues, key)) {
                    indexedValues[this.getSlotKey('video', key, index)] = videoValues[key];
                }
            }
        });

        this.setPrefixedIndexedValues('video_', indexedValues);
    }

    public clearIndexedValuesForVideo(): void {
        this.clearPrefixedIndexedValues('video_');
    }

    private getDefaultIndexedValuesForVideo(video){
        if(!video) {
            return {};
        }
        let indexedValues = {};
        indexedValues['video_default_name'] = video.title || '';
        indexedValues['video_default_url'] = video.url || '';
        indexedValues['video_default_thumbnail_url'] = video.thumbnail ? video.thumbnail.url : '';
        indexedValues['video_default_description'] = video.description || '';
        indexedValues['video_default_length'] = video.length || '';
        indexedValues['video_default_mime_type'] = video.mimeType || '';
        indexedValues['video_default_width'] = video.width || '';
        indexedValues['video_default_height'] = video.height || '';
        indexedValues['video_default_ratio'] = video.ratio || '';
        indexedValues['video_default_primary_content_type'] = video.details && video.details.contentType ? video.details.contentType.name : '';
        indexedValues['video_default_primary_content_type_color'] = video.details && video.details.contentType ? video.details.contentType.color : '';
        indexedValues['video_default_primary_category'] = video.details && video.details.primaryCategory ? video.details.primaryCategory.name : '';
        indexedValues['video_default_primary_tag'] = video.details && video.details.primaryTag ? video.details.primaryTag.name : '';
        return indexedValues;
    }

    //===============================================
    //hub related functions
    public setIndexedValuesForHubs(hubs: any[]): void {
        if (!Array.isArray(hubs) || hubs.length === 0) {
            this.clearIndexedValuesForHubs();
            return;
        }

        let indexedValues = {};

        hubs.forEach((hub, index) => {
            const hubValues = this.getDefaultIndexedValuesForHub(hub);
            for (const key in hubValues) {
                if (Object.prototype.hasOwnProperty.call(hubValues, key)) {
                    indexedValues[this.getSlotKey('hub', key, index)] = hubValues[key];
                }
            }
        });

        this.setPrefixedIndexedValues('hub_', indexedValues);
    }

    public clearIndexedValuesForHubs(): void {
        this.clearPrefixedIndexedValues('hub_');
    }

    private getDefaultIndexedValuesForHub(hub){
        if(!hub) {
            return {};
        }
        let indexedValues = {};
        indexedValues['hub_default_name'] = hub.name || '';
        indexedValues['hub_default_url'] = hub.permalink || '';
        indexedValues['hub_default_description'] = hub.description || '';
        indexedValues['hub_default_thumbnail_image_url'] = hub.thumbnailImage ? hub.thumbnailImage.url : '';
        indexedValues['hub_default_banner_image_url'] = hub.bannerImage ? hub.bannerImage.url : '';

        return indexedValues;
    }

    //===============================================
    //listing page context (page-context phase parity)
    public setIndexedValuesForListingPageContext(listingPage: any): void {
        if (!listingPage) {
            this.clearIndexedValuesForListingPageContext();
            return;
        }

        const contextValues = this.getDefaultIndexedValuesForListingPageContext(listingPage);
        const currentValues = Object.assign({}, this.getTemplateViewModel().indexedHtmlValues());

        // Always refresh listing_page_* values from the selected listing page.
        this.removeIndexedValues(currentValues, (key: string) => key.indexOf('listing_page_') === 0);

        for (const key in contextValues) {
            if (!Object.prototype.hasOwnProperty.call(contextValues, key)) {
                continue;
            }

            const value = contextValues[key];
            if (value === null || value === undefined || value === '') {
                continue;
            }

            currentValues[key] = value;
        }

        this.setIndexedValuesCollection(currentValues);
    }

    public clearIndexedValuesForListingPageContext(): void {
        this.clearPrefixedIndexedValues('listing_page_');
    }

    public getDefaultIndexedValuesForListingPageContext(listingPage: any): { [key: string]: any } {
        if (!listingPage) {
            return {};
        }

        const imageUrl = listingPage.featuredImage
            ? (listingPage.featuredImage.url || listingPage.featuredImage.src || '')
            : (listingPage.thumbnailImage ? listingPage.thumbnailImage.url : '');
        const bannerUrl = listingPage.bannerImage
            ? listingPage.bannerImage.url
            : imageUrl;
        const name = listingPage.name || '';
        const permalink = listingPage.permalink || '';
        const description = listingPage.description || '';
        const articleCount = Math.max(0, parseInt(String(listingPage.articleCount != null ? listingPage.articleCount : 0), 10) || 0);
        const articlesUrl = articleCount > 0 && permalink
            ? String(permalink).replace(/\/?$/, '/') + 'articles/'
            : '';

        return {
            listing_page_default_name: name,
            listing_page_default_url: permalink,
            listing_page_default_description: description,
            listing_page_default_thumbnail_image_url: imageUrl,
            listing_page_default_banner_image_url: bannerUrl,
            listing_page_default_article_count: String(articleCount),
            listing_page_default_articles_url: articlesUrl,
        };
    }

    //===============================================
    //brand related functions
    public setBrandReferences(brandReferences: { [key: string]: any } = {}): void {
        if (!brandReferences || typeof brandReferences !== 'object') {
            return;
        }

        const currentValues = Object.assign({}, this.getTemplateViewModel().indexedHtmlValues());

        for (const key in brandReferences) {
            if (Object.prototype.hasOwnProperty.call(brandReferences, key)
                && brandReferences[key] !== undefined
                && brandReferences[key] !== null) {
                currentValues[key.toLowerCase()] = brandReferences[key];
            }
        }

        this.setIndexedValuesCollection(currentValues);
    }
    
    public static formatBrandReferences(brandReferences: any, labels: any): any[] {
        if (!brandReferences || typeof brandReferences !== 'object') {
            return [];
        }
        return Object.keys(brandReferences).map((key) => ({
            key: labels[key] || key.replace(/_/g, ' ').toUpperCase(),
            value: key,
        }));
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettePreview_template.ts